/* eslint-disable */
import { getLocale, experimentalStaticLocale } from "../runtime.js"

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Closeeditorbutton2Inputs */
/** @typedef {{}} Closeeditorbuttontitle3Inputs */
/** @typedef {{}} Confirmcloseeditor2Inputs */
/** @typedef {{}} Defaultexample1Inputs */
/** @typedef {{}} Openeditorbutton2Inputs */
/** @typedef {{ "background:darkgreen": NonNullable<unknown> }} Readme1Inputs */
/** @typedef {{}} Redirectlabel1Inputs */
/** @typedef {{}} Redirectplaceholder1Inputs */
/** @typedef {{}} Rulesreminder1Inputs */
import * as __fr from "./fr.js"
import * as __en from "./en.js"
import * as __it from "./it.js"
/**
* | output |
* | --- |
* | "Close the editor" |
*
* @param {Closeeditorbutton2Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const closeeditorbutton2 = /** @type {((inputs?: Closeeditorbutton2Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closeeditorbutton2Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.closeeditorbutton2(inputs)
	if (locale === "it") return __it.closeeditorbutton2(inputs)
	return __fr.closeeditorbutton2(inputs)
});
export { closeeditorbutton2 as "closeEditorButton" }
/**
* | output |
* | --- |
* | "Close the Markdown editor" |
*
* @param {Closeeditorbuttontitle3Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const closeeditorbuttontitle3 = /** @type {((inputs?: Closeeditorbuttontitle3Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Closeeditorbuttontitle3Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.closeeditorbuttontitle3(inputs)
	if (locale === "it") return __it.closeeditorbuttontitle3(inputs)
	return __fr.closeeditorbuttontitle3(inputs)
});
export { closeeditorbuttontitle3 as "closeEditorButtonTitle" }
/**
* | output |
* | --- |
* | "Do you really want to close the Markdown editor? Your changes will be lost if you haven't copied the content." |
*
* @param {Confirmcloseeditor2Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const confirmcloseeditor2 = /** @type {((inputs?: Confirmcloseeditor2Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirmcloseeditor2Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.confirmcloseeditor2(inputs)
	if (locale === "it") return __it.confirmcloseeditor2(inputs)
	return __fr.confirmcloseeditor2(inputs)
});
export { confirmcloseeditor2 as "confirmCloseEditor" }
/**
* | output |
* | --- |
* | "Hello ! Hi ! ![](assets/perso_educajou.svg) ![](assets/brigit_et_komit.png) Brigit & Komit" |
*
* @param {Defaultexample1Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const defaultexample1 = /** @type {((inputs?: Defaultexample1Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Defaultexample1Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.defaultexample1(inputs)
	if (locale === "it") return __it.defaultexample1(inputs)
	return __fr.defaultexample1(inputs)
});
export { defaultexample1 as "defaultExample" }
/**
* | output |
* | --- |
* | "Open the online editor" |
*
* @param {Openeditorbutton2Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const openeditorbutton2 = /** @type {((inputs?: Openeditorbutton2Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openeditorbutton2Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.openeditorbutton2(inputs)
	if (locale === "it") return __it.openeditorbutton2(inputs)
	return __fr.openeditorbutton2(inputs)
});
export { openeditorbutton2 as "openEditorButton" }
/**
* | output |
* | --- |
* | "# MemoryMD **MemoryMD** is a free and open-source application that lets you create matching games from simple Markdown text. You can create games that match:..." |
*
* @param {Readme1Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const readme1 = /** @type {((inputs: Readme1Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Readme1Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.readme1(inputs)
	if (locale === "it") return __it.readme1(inputs)
	return __fr.readme1(inputs)
});
export { readme1 as "readMe" }
/**
* | output |
* | --- |
* | "Copy the link to your file here, then click “OK” to open your Memory Game:" |
*
* @param {Redirectlabel1Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const redirectlabel1 = /** @type {((inputs?: Redirectlabel1Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Redirectlabel1Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.redirectlabel1(inputs)
	if (locale === "it") return __it.redirectlabel1(inputs)
	return __fr.redirectlabel1(inputs)
});
export { redirectlabel1 as "redirectLabel" }
/**
* | output |
* | --- |
* | "Your URL" |
*
* @param {Redirectplaceholder1Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const redirectplaceholder1 = /** @type {((inputs?: Redirectplaceholder1Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Redirectplaceholder1Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.redirectplaceholder1(inputs)
	if (locale === "it") return __it.redirectplaceholder1(inputs)
	return __fr.redirectplaceholder1(inputs)
});
export { redirectplaceholder1 as "redirectPlaceholder" }
/**
* | output |
* | --- |
* | "**Rule 1** Separate each card with an empty line. **Rule 2** If you want to pair two elements, write the first element on one line, then go to the next line ..." |
*
* @param {Rulesreminder1Inputs} inputs
* @param {{ locale?: "fr" | "en" | "it" }} options
* @returns {LocalizedString}
*/
const rulesreminder1 = /** @type {((inputs?: Rulesreminder1Inputs, options?: { locale?: "fr" | "en" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rulesreminder1Inputs, { locale?: "fr" | "en" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return __en.rulesreminder1(inputs)
	if (locale === "it") return __it.rulesreminder1(inputs)
	return __fr.rulesreminder1(inputs)
});
export { rulesreminder1 as "rulesReminder" }